export const ICON_PATHS = {
  BALLOON: '/images/balloonIcon.png',
  BALLOON_HOVERED: '/images/balloonIconHovered.png',
  BALLOON_ACTIVE: '/images/balloonIconActive.png',
  CLUSTER: '/images/clusterIconLayout.png',
  CLUSTER_HOVERED: '/images/clusterIconLayoutHovered.png',
  CLUSTER_ACTIVE: '/images/clusterIconLayoutActive.png',
} as const;
